<!--
 * @创建文件时间: 2019-11-10 11:24:30
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2021-11-01 10:28:02
 * @联系Qq:1638245306
 * @文件介绍: 
 -->
<template>
  <div>
    <el-dropdown size="small" class="d2-mr">
      <span class="btn-text" style="color:#fff;">{{
        userName ? `你好 ${userName}` : "未登录"
      }}</span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="dialogVisible = true">
          <d2-icon name="lock" class="d2-mr-5" />
          修改密码
        </el-dropdown-item>
        <el-dropdown-item @click.native="logOff" divided>
          <d2-icon name="power-off" class="d2-mr-5" />
          注销
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div>
      <el-dialog
        title="修改密码"
        :visible.sync="dialogVisible"
        width="400px"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
      >
        <el-form :model="form" :inline="true" label-width="80px">
          <el-form-item label="当前账号">
            <el-input
              v-model="form.account"
              disabled
              clearable
              placeholder="请输入当前账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="旧密码">
            <el-input
              v-model="form.oldPwd"
              show-password
              clearable
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input
              v-model="form.newPwd"
              show-password
              clearable
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="changePwd">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import md5 from "js-md5";
import util from '@/libs/util.js'
import { Message, MessageBox } from 'element-ui'
export default {
  computed: {
    ...mapState("d2admin/user", ["info"]),
  },
  data() {
    return {
      dialogVisible: false,
      userName: "",
      form: {
        oldPwd: "",
        newPwd: "",
        account: "",
      },
    };
  },
  methods: {
    ...mapActions("d2admin/account", ["logout"]),
    /**
     * @description 登出
     */
    logOff() {
      let that = this;
      // this.logout({
      //   confirm: true,
      // });
      /**
       * @description 注销
       */
      async function logout() {
        // this.$http
        //   .post(this.$url.user.loginout, {})
        //   .then((res) => {
        // 清空 vuex 用户信息
        that.$http.post(that.$url.user.loginout, {}).then((res) => {
          that.$store.dispatch('d2admin/user/set', {}, { root: true })
          // 删除cookie
          util.session.remove('token')
          util.cookies.remove('token')
          util.cookies.remove('uuid')
          // 跳转路由
          that.$router.push({ path: "/login" });
        });
        // });
      }
      // 判断是否需要确认
      if (confirm) {
        this.$store.commit('d2admin/gray/set', true, { root: true })
        MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
          type: 'warning'
        })
          .then(() => {
            this.$store.commit('d2admin/gray/set', false, { root: true })
            logout()


          })
          .catch(() => {
            this.$store.commit('d2admin/gray/set', false, { root: true })
            Message({
              message: '取消注销操作'
            })
          })
      } else {
        logout()
      }
    },
    changePwd() {
      let pwdRegex = new RegExp(
        "(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}"
      );
      if (!pwdRegex.test(this.form.newPwd)) {
        this.$message.error(
          "密码中必须包含大小写字母、数字、特殊字符,且密码长度大于8小于30"
        );
      } else {
        let oldPwd = md5(this.form.oldPwd);
        let newPwd = md5(this.form.newPwd);
        this.$http
          .post(this.$url.authority.updatepassword, {
            account: this.form.account,
            oldPwd: oldPwd,
            newPwd: newPwd,
          })
          .then((res) => {
            this.$alert("修改成功,请重新登陆", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ path: "/login" });
              },
            });
          });
      }
    },
  },
  created() {
    if (this.info.userData) {
      this.userName = this.info.userData.realName;
      this.$store.dispatch("d2admin/user/load").then((data) => {
        this.form.account = data.account;
      });
    }
  },
};
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
